import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loader: false,
};

export const loaderSlice = createSlice({
  name: 'loaderSlice',
  initialState,
  reducers: {
    setLoaderTrue: (state) => {
      state.loader = true;
    },
    setLoaderFalse: (state) => {
      state.loader = false;
    },
  },
});

export const { setLoaderTrue, setLoaderFalse } = loaderSlice.actions;

export default loaderSlice.reducer;
